import React from "react";
import { FaTimes } from "react-icons/fa";

const SlidingDiv = ({
  isVisible,
  onClose,
  width = "w-1/4",
  children,
  backgroundColor = "bg-gray-800",
  textColor = "text-white",
}) => {
  return (
    <div
      className={`fixed top-0 right-0 h-full ${width} ${backgroundColor} ${textColor} shadow-2xl transition-transform duration-300 ${
        isVisible ? "translate-x-0" : "translate-x-full"
      }`}
    >
      {/* Close Icon */}
      <FaTimes
        onClick={onClose}
        className="float-right m-5 text-lg text-red-500 cursor-pointer"
      />
      <div className="p-4">{children}</div>
    </div>
  );
};

export default SlidingDiv;
